import { Button, TextField } from "@mui/material";
import { useBoundStore } from "useStore";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

export default function DateFilter() {
  const searchObject = useBoundStore((state) => state.soAdminSearch);
  const setSearchObject = useBoundStore((state) => state.setSoAdminSearch);
  const isLoading = useBoundStore((state) => state.soAdminIsLoading);
  const datePickerStyles = {
    width: 300,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      backgroundColor: "#fff !important",
      borderRadius: "8px",
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },
  };
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          disabled={isLoading}
          label="Desde"
          value={searchObject.startDate}
          inputFormat="dd/MM/yyyy"
          onChange={(newValue) => {
            setSearchObject({ ...searchObject, startDate: newValue });
          }}
          components={{
            OpenPickerIcon: () => (
              <CalendarTodayOutlinedIcon sx={{ color: "#0000008F" }} />
            ),
          }}
          slots={{ openPickerIcon: CalendarTodayOutlinedIcon }}
          slotProps={{
            openPickerIcon: { sx: { color: "#0000008F" } },
            textField: { sx: datePickerStyles },
          }}
          className="input_date_admin"
          renderInput={(params) => (
            <TextField {...params} sx={datePickerStyles} />
          )}
        />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          disabled={isLoading}
          label="Hasta"
          value={searchObject.endDate}
          components={{
            OpenPickerIcon: () => (
              <CalendarTodayOutlinedIcon sx={{ color: "#0000008F" }} />
            ),
          }}
          inputFormat="dd/MM/yyyy"
          onChange={(newValue) => {
            setSearchObject({ ...searchObject, endDate: newValue });
          }}
          className="input_date_admin"
          slotProps={{
            openPickerIcon: { sx: { color: "#0000008F" } },
            textField: { sx: datePickerStyles },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={datePickerStyles} />
          )}
        />
      </LocalizationProvider>
    </>
  );
}
